<template>
  <el-container class="ipo3_layout">
    <el-header class="ipo3_header" :height="headerHeight">
      <ipo3-header></ipo3-header>
    </el-header>
    <el-container>
      <el-aside :width="leftWidth" class="ipo3_menus">
        <left-menus></left-menus>
      </el-aside>
      <el-container>
        <el-main class="ipo3_container">
          <router-view />
        </el-main>
        <!-- <el-footer :height="footerHeight" class="ipo3_footer">由新平江提供技术支持</el-footer> -->
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import Ipo3Header from "./header.vue";
import LeftMenus from "./menus.vue";
export default {
  name: "layout",
  components: { Ipo3Header, LeftMenus },
  data() {
    return {
      leftWidth: "150px",
      headerHeight: "55px",
      footerHeight: "30px"
    };
  }
};
</script>

<style lang="less">
.ipo3_layout {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  ::-webkit-scrollbar
    {
      display:none;
    }
  .el-container {
    overflow: scroll;
    ::-webkit-scrollbar
    {
      display:none;
    }
  }
  .el-header {
    padding: 0px;
  }
  .ipo3_header {
    height: 55px;
    background-image: linear-gradient(to right, #0f6ad7, #00ced4);

    // background: rgba(26, 114, 212, 1);
    color: white;
  }
  .ipo3_menus {
    background: rgba(40, 47, 73, 1);
    border-right: 1px solid #ddd;
    overflow: hidden;
  }
  .ipo3_container {
    background: #e8eaf6;
    
  }
  .ipo3_footer {
    background: #ddd;
    line-height: 30px;
    color: black;
    font-size: 12px;
  }
}
</style>